import { Quote } from "lucide-react";
import { Reveal } from "./Motion";
import { testimonialsFor } from "@/data/testimonials";

export const Testimonials = ({ networkKey, accent = "#B4532A" }) => {
  const items = testimonialsFor(networkKey);
  if (!items.length) return null;
  const hasSamples = items.some((t) => t.sample);
  return (
    <section className="max-w-7xl mx-auto px-5 sm:px-8 pb-24 sm:pb-32" data-testid="testimonials-section">
      <Reveal className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <div className="font-mono text-xs uppercase tracking-[0.25em]" style={{ color: accent }}>What families say</div>
          <h2 className="mt-4 font-serif text-3xl sm:text-4xl tracking-tight text-[#1F1A17]">Quiet words from <em>people who use it.</em></h2>
        </div>
        {hasSamples && (
          <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#685F58] border border-dashed border-[#E8DDD3] rounded-full px-3 py-1.5" data-testid="testimonials-sample-badge">
            Sample quotes — real ones coming
          </span>
        )}
      </Reveal>
      <div className="mt-10 grid md:grid-cols-3 gap-5">
        {items.map((t, i) => (
          <Reveal key={t.name} delay={i * 0.1}>
            <figure data-testid={`testimonial-${i}`} className="relative h-full rounded-3xl border border-[#E8DDD3] bg-white p-8 transition-transform duration-500 hover:-translate-y-1">
              <Quote className="h-6 w-6" style={{ color: accent }} fill="currentColor" />
              <blockquote className="mt-5 font-serif text-xl leading-snug tracking-tight text-[#1F1A17]">“{t.quote}”</blockquote>
              <figcaption className="mt-6 flex items-center gap-3">
                <span className="h-9 w-9 rounded-full grid place-items-center text-sm font-medium text-white" style={{ background: accent }}>{t.name[0]}</span>
                <span className="leading-tight">
                  <span className="block text-sm font-medium text-[#1F1A17]">{t.name}</span>
                  <span className="block text-xs text-[#685F58]">{t.role}</span>
                </span>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </section>
  );
};
